const module = { name: 'movie/shared/showtimesUI', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_account_context_logInUrls } from 'require-core';

const { account: { isVerifiedLoggedIn }, context, logInUrls } = Fandango_account_context_logInUrls;


import { global_consts as global_consts_CookieNames_QueryParams } from 'require-core';

const { CookieNames, QueryParams } = global_consts_CookieNames_QueryParams;


import { Fandango_cookie as Fandango_cookie_delete_deleteCookie } from 'require-core';

const { delete: deleteCookie } = Fandango_cookie_delete_deleteCookie;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes } from 'require-global';

const { EventTypes } = Fandango_adobeLaunch_EventTypes;


import { Fandango_util as Fandango_util_formatDate } from 'require-global';

const { formatDate } = Fandango_util_formatDate;


import { default as amenityDropdown } from 'swug-fdRequire-call:desktop/shared/amenityDropdown';



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { default as datePicker } from 'swug-fdRequire-call:movie/shared/datePicker';



import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_eventQueue as eventQueue } from 'require-global';



import { Fandango_popup as fandangoPopup } from 'base-libraries';



const { EventNames } = eventQueue


import { default as hearts } from 'swug-fdRequire-call:shared/utils/hearts';



import { fd_url_manager as links } from 'require-core';



import { swig as swig } from 'require-core';



import { Fandango_queryUtil as queryUtil } from 'require-core';



import { default as seatMap } from 'swug-fdRequire-call:shared/seatMap/seatMap';



import { default as sharedShowtimes } from 'swug-fdRequire-call:shared/sharedShowtimes';



import { default as theater_shared_locationHelpers_formatTheaterDistance } from 'swug-fdRequire-call:theater/shared/locationHelpers';

const { formatTheaterDistance } = theater_shared_locationHelpers_formatTheaterDistance;


import { Fandango as Fandango_pageDetails } from 'require-core';

let { pageDetails } = Fandango_pageDetails;


import { default as Fandango_triggerEvent_triggerAnalyticsEvent } from 'swug-fdRequire-call:Fandango/triggerEvent';

const { triggerAnalyticsEvent } = Fandango_triggerEvent_triggerAnalyticsEvent;


import { default as bannerMPS } from 'swug-fdRequire-call:movie/shared/bannerMPS';



import { default as formatFilter } from 'swug-fdRequire-call:movie/shared/formatFilter';



import { default as historyStates } from 'swug-fdRequire-call:movie/shared/historyStates';



import { shared_global_smoothScroll as smoothScroll } from 'require-global';



import { default as theaterConcessionAmenity } from 'swug-fdRequire-call:theater/shared/theaterConcessionAmenity';



const Selectors = Object.freeze({
    ARIA_LIVE: '#aria-live-mop',
    DATE_PICKER: 'date-picker',
    DESKTOP_BUY_TICKETS_BTN: '#mop-desktop-buy-tickets-btn',
    DESKTOP_MOP_INFO_BLOCK_WRAP: '#mop-info-bloc-wrap',
    DESKTOP_MOP_INFO_WRAP: '#mop-info-wrap',
    FAN_ALERT_SECTION: '#new-fan-alert',
    FILTER_LOADING: '.js-filteredChain-lazy',
    FORMAT_FILTER: '.js-format-filter',
    FUTURE_DATE_NOTICE: '#future-date-notice',
    IN_THEATERS_CONTAINER: '#in-theaters-container',
    MOP_MERCH_CARD: '.js-merch-card',
    MOP_MERCH_CARD_MODAL_BTN: '.js-merch-card-modal-btn',
    MOP_MERCH_CARD_POPUP_MID: '#bundle-merch-card-popup-mid',
    MOP_MERCH_CARD_POPUP_TOP: '#bundle-merch-card-popup-top',
    MOVIE_SHOWTIME_THEATER: '.js-movie-showtime-theater',
    REMOVE_ALL_FILTERS_BTN: '.js-filtered-btn',
    SEE_MORE_THEATERS_BTN: '#see-more-theaters-btn',
    SEE_MORE_THEATERS_BTN_WRAPPER: '#see-more-theaters-btn-wrap',
    SELECTED_FORMAT: '#mop-selected-format',
    SHARED_SHOWTIMES: 'shared-showtimes',
    SHARED_THEATER_HEADER: 'shared-theater-header',
    SHOWTIME_CONTENT: '.js-movie-showtimes-content',
    SHOWTIME_LOADING: '#movie-showtimes-loading',
    SHOWTIMES: '#lazyload-movie-times',
    CONTAINER: '#lazyload-format-filters',
    TOP_BUNDLE: '#top-bundle-placeholder',
    MID_BUNDLE: '#mid-bundle-placeholder',
    MOBILE_BUY_TICKETS_OUTLINE_BTN_WRAP: '.movie-detail__icon-ticket-outline-wrap',
    MOBILE_VIEWING_TYPE_TOGGLE_WRAPPER: '.viewing-type-toggle__wrapper--mweb',
    MOBILE_VIEWING_TYPE_TOGGLE_BTN: '.js-viewing-type-toggle-btn'
})


const Styles = Object.freeze({
    DESKTOP_MOP_INFO_BLOCK_WRAP: 'movie-detail-header__info-bloc-wrap',
    DESKTOP_MOP_INFO_WRAP: 'movie-detail__info-wrap',
    FORMAT_ACTIVE: 'format-filter__list-item--active',
    HIDE: 'hide',
})


const Attribs = {
    CHECKED: 'aria-checked',
}


const { affiliateId, isDesktop, joinNowURL, newFanAlertEnabled } = readPageContext(context, logInUrls)


let activeFormatFilter


let allTheaterShowtimes


let movieTitle


let showtimeDate


let hasShowtimes


const MerchCardPopups = {
    mid: {},
    top: {},
}
function readPageContext(context, logInUrls) {
    const { device, req: { route } } = context || {};
    const { joinNow: joinNowURL } = logInUrls || {};
    return {
        affiliateId: queryUtil.getParam(QueryParams.AFFILIATE_ID),
        isDesktop: !device.isMobile,
        joinNowURL,
        newFanAlertEnabled,
        route,
    };
}
function triggerMopEvent(eventName, extraData = {}) {
    triggerAnalyticsEvent(eventName, {
        pageName: 'movie | overview',
        pageType: 'movie overview page',
        contentTile: movieTitle || '',
        ...extraData
    });
}
function unshowBusy() {
    document.querySelector(Selectors.SHOWTIME_LOADING).classList.add(Styles.HIDE);
}
function showBusy() {
    const markup = swig.render('_mopShowtimesPlaceholder');
    $(Selectors.SHOWTIME_CONTENT).html(markup);
}
function toFullAddressStr(theater) {
    const { address1, city, region, postalCode } = theater || {};
    return [address1, city, `${region || ''} ${postalCode || ''}`]
        .map(t => t && t.trim())
        .filter(Boolean)
        .join(', ');
}
function onTheaterFilterBtnClick() {
    deleteCookie(CookieNames.CHAIN_CODE);
    historyStates.push(historyStates.HistoryEventTypes.REMOVE_CHAIN_FILTER);
    showBusy();
    $(Selectors.FILTER_LOADING).addClass(Styles.HIDE);
    displayFilteredShowings(null);
}
function onFilterClick() {
    const format = this.dataset.format;
    if (!format || format === activeFormatFilter) {
        return;
    }
    triggerMopEvent(EventTypes.FORMAT_SELECTED, {
        formatSelected: format
    });
    updateSelected(this);
    displayFilteredShowings(format);
    renderMopBundle();
}
function onMerchCardClick(e, isButton) {
    const { campaign, position } = e.currentTarget.dataset;
    const merchCardPopup = MerchCardPopups[position];
    triggerMopEvent(EventTypes.GENERIC_CLICK, {
        clickDetails: `mop | merch tile click | ${campaign}`,
    });
    if (isButton && merchCardPopup) {
        merchCardPopup.open();
        merchCardPopup.children[0].scrollTop = 0;
    }
}
function onSeeMoreTheatersClick() {
    $(Selectors.ARIA_LIVE).text('Displaying more showtimes nearby');
    $(Selectors.MOVIE_SHOWTIME_THEATER).removeClass(Styles.HIDE);
    $(Selectors.SEE_MORE_THEATERS_BTN_WRAPPER).addClass(Styles.HIDE);
}
function attachEvents() {
    $(Selectors.FORMAT_FILTER).off('click').on('click', onFilterClick);
    $(Selectors.SEE_MORE_THEATERS_BTN).off('click').on('click', onSeeMoreTheatersClick);
}
function afterMarkupInjection(opts) {
    opts = opts || {};
    hearts.init();
    seatMap.renderModal();
    amenityDropdown.run();
    if (opts.hasShowtimes) {
        bannerMPS.topBannerExists(opts.hasShowtimes, (hasBanner) => {
            if (hasBanner) {
                bannerMPS.removeBannerTopAd();
            }
        });
    }
    bannerMPS.displayBannerTopAd();
    bannerMPS.displayBannerMidAd();
    datePicker.highlightDate(Selectors.DATE_PICKER, opts.date);
    attachEvents();
}
function getShowtimePresence(showTicketingPresale, isStreaming, hasShowtimes) {
    if (showTicketingPresale) {
        return 'showtimes in future';
    }
    if (isStreaming && !hasShowtimes) {
        return 'streaming';
    }
    if (isStreaming && hasShowtimes) {
        return 'streaming and showtimes';
    }
    if (!isStreaming && !hasShowtimes) {
        return 'fanalerts';
    }
    return 'showtimes present';
}
function noShowtimesView(opts) {
    const { showTicketingPresale, showStreaming, hasShowtimes, showFanalert, date } = opts || {};
    const fanAlertEnabled = context.featureFlags.fanAlertEnabled;
    unshowBusy();
    const { FormatFilters } = formatFilter;
    let formatSelected = FormatFilters.ALL;
    if (showTicketingPresale) {
        $(Selectors.FUTURE_DATE_NOTICE).removeClass(Styles.HIDE);
        formatSelected = activeFormatFilter || FormatFilters.ALL;
    }
    else if (activeFormatFilter) {
        afterMarkupInjection({
            date: date || formatDate(new Date()),
            hasShowtimes: false
        });
        formatSelected = activeFormatFilter;
    }
    if (showFanalert && fanAlertEnabled) {
        $(Selectors.FAN_ALERT_SECTION).removeClass(Styles.HIDE);
        eventQueue.emit(EventNames.FAN_ALERT_READY);
    }
    triggerMopEvent(EventTypes.DATE_SHOWTIME_FORMAT, {
        showtimePresence: getShowtimePresence(showTicketingPresale, showStreaming, hasShowtimes),
        selectedDate: date,
        formatSelected,
    });
}
function onBuyTicketsClick() {
    const inTheatersContainer = document.querySelector(Selectors.IN_THEATERS_CONTAINER);
    if (!inTheatersContainer) {
        return;
    }
    const hasMobileToggle = document.querySelector(Selectors.MOBILE_VIEWING_TYPE_TOGGLE_WRAPPER) &&
        document.querySelectorAll(Selectors.MOBILE_VIEWING_TYPE_TOGGLE_BTN).length > 0;
    if (hasMobileToggle) {
        const inTheatersTab = document.querySelector(Selectors.MOBILE_VIEWING_TYPE_TOGGLE_BTN + '[data-tab="buytickets"]');
        if (inTheatersTab) {
            inTheatersTab.click();
        }
    }
    const scrollOffset = hasMobileToggle ? 122 : 50;
    $('html, body').animate({
        scrollTop: $(inTheatersContainer).offset().top - scrollOffset,
    }, 500);
}
function filterTheaterShowtimesList(filter, theaters) {
    if (filter === formatFilter.FormatFilters.ALL) {
        return theaters;
    }
    return theaters
        .filter(theater => Array.isArray(theater?.variants) || theater.variants.length)
        .map(theater => ({
        ...theater,
        sourceVariants: theater.variants.map(variant => ({ ...variant, sourceAmenityGroups: variant.amenityGroups }))
    }))
        .filter((theater) => {
        theater.variants = theater.variants.map((variant, index) => ({
            ...variant,
            amenityGroups: theater.sourceVariants[index].sourceAmenityGroups
                .filter(group => group.showtimes.some(showtime => showtime.filmFormat.some(f => f.filterName === filter)))
        }));
        return theater.variants.some(variant => variant.amenityGroups.length > 0);
    });
}
function renderMopBundle() {
    const { mid, top } = pageDetails.bundleMerchCards || {};
    if (top?.enabled) {
        const topElement = $(Selectors.TOP_BUNDLE);
        const topTemplate = top.modalHtmlBody ? '_mopBundleCardButton' : '_mopBundleCardLink';
        topElement.html(swig.render(topTemplate, { ...top, isDesktop }));
        MerchCardPopups.top = fandangoPopup.attach(Selectors.MOP_MERCH_CARD_POPUP_TOP);
        topElement.removeClass(Styles.HIDE);
    }
    if (mid?.enabled) {
        const midElement = $(Selectors.MID_BUNDLE);
        const midTemplate = mid.modalHtmlBody ? '_mopBundleCardButton' : '_mopBundleCardLink';
        midElement.html(swig.render(midTemplate, { ...mid, isDesktop }));
        MerchCardPopups.mid = fandangoPopup.attach(Selectors.MOP_MERCH_CARD_POPUP_MID);
        midElement.removeClass(Styles.HIDE);
    }
    $(Selectors.MOP_MERCH_CARD).off('click').on('click', onMerchCardClick);
    $(Selectors.MOP_MERCH_CARD_MODAL_BTN).off('click').on('click', e => onMerchCardClick(e, true));
}
function displayFilteredShowings(filter, movie) {
    if (!allTheaterShowtimes) {
        debugLog.warn(`${module.name}'.applyFilter`, 'no data ready/available');
        return;
    }
    const { seatMapPreviewEnabled } = context.featureFlags;
    const allFormat = formatFilter.FormatFilters.ALL;
    if (!filter || !allTheaterShowtimes.formats.availableFormats.includes(filter)) {
        debugLog.warn(`${module.name}'.applyFilter`, 'invalid filter, using "ALL"');
        filter = allFormat;
    }
    activeFormatFilter = filter;
    historyStates.push(historyStates.HistoryEventTypes.FORMAT_FILTER, filter === allFormat ? null : filter);
    const theaters = filterTheaterShowtimesList(filter, allTheaterShowtimes.theaters);
    const hasShowtimes = Boolean(theaters.length);
    const viewModel = { activeFilter: filter.toUpperCase(), hasShowtimes, isDesktop, theaters };
    document.querySelector(Selectors.SHOWTIME_CONTENT).innerHTML = swig.render('_theaterShowtimeGroupings', viewModel);
    theaters.forEach((theater) => {
        if (theater.distance) {
            formatTheaterDistance(theater, 2);
        }
        const theaterHeaderEl = document.getElementById(`${Selectors.SHARED_THEATER_HEADER}-${theater.id}`);
        const innerContent = swig.render('_sharedTheaterHeaderContent', { isFullLinkHeader: false, theater });
        if (theaterHeaderEl) {
            theaterHeaderEl.outerHTML = swig.render('_sharedTheaterHeader', {
                concessionsEnabled: allTheaterShowtimes.concessionsEnabled,
                innerContent,
                isVerifiedLoggedIn,
                theater,
            });
        }
        const showtimesEl = document.getElementById(`${Selectors.SHARED_SHOWTIMES}-${theater.id}`);
        if (showtimesEl) {
            showtimesEl.outerHTML = swig.render('_sharedShowtimes', {
                affiliateId,
                movie,
                seatMapPreviewEnabled,
                showtimeDate,
                theater,
                variants: seatMap.addSeatMapData(theater.variants),
            });
        }
    });
    theaterConcessionAmenity.init(theaters);
    const anchor = queryUtil.getParam(QueryParams.MOVE_TO) || window.location.hash.slice(1);
    smoothScroll.run(anchor);
    sharedShowtimes.init();
    afterMarkupInjection({
        date: showtimeDate,
        hasShowtimes,
    });
}
function updateSelected(ele) {
    document.querySelectorAll(Selectors.FORMAT_FILTER).forEach((btn) => {
        const parent = btn.parentElement;
        if (btn === ele) {
            btn.setAttribute(Attribs.CHECKED, true);
            parent.classList.add(Styles.FORMAT_ACTIVE);
        }
        else {
            btn.removeAttribute(Attribs.CHECKED);
            parent.classList.remove(Styles.FORMAT_ACTIVE);
        }
    });
}
function hideFilters() {
    document.querySelector(Selectors.CONTAINER).classList.add(Styles.HIDE);
}
function loader(formats) {
    if (!Array.isArray(formats) || !formats.length) {
        return hideFilters();
    }
    else {
        document.querySelector(Selectors.CONTAINER).classList.remove(Styles.HIDE);
    }
    const viewModel = {
        all: [...formats],
        availableFormats: formats,
    };
    if (!activeFormatFilter) {
        activeFormatFilter = decodeURIComponent(queryUtil.getParam(QueryParams.FORMAT) || formatFilter.FormatFilters.ALL);
    }
    const markup = formatFilter.getMarkup(viewModel, activeFormatFilter, true);
    const container = document.querySelector(Selectors.CONTAINER);
    if (!markup || !container) {
        return;
    }
    container.innerHTML = markup;
    attachEvents();
}
function onDone(opts, cb) {
    const { adobeLaunch, date, movie, movieAttribs, showtimes } = opts || {};
    const { hasShowtimes: showtimesAvailable, theaterShowtimes } = showtimes;
    const { releaseDate } = movie;
    const { showFanalert, showTicketingPresale, showStreaming } = movieAttribs;
    const { trackingState, trackingAttribs } = adobeLaunch;
    const availableFormats = theaterShowtimes?.formats.availableFormats;
    hasShowtimes = showtimesAvailable;
    movieTitle = movie.title;
    showtimeDate = showtimes.date;
    if (theaterShowtimes) {
        allTheaterShowtimes = Object.assign(theaterShowtimes, {
            theaters: theaterShowtimes.theaters.map((theater) => {
                const fullAddress = toFullAddressStr(theater);
                return {
                    ...theater,
                    fullAddress,
                    joinNowURL: `${joinNowURL}${links.setFavoriteTheaterParams({ id: theater.id })}`
                };
            })
        });
    }
    if (availableFormats) {
        loader(availableFormats);
    }
    else {
        hideFilters();
    }
    triggerMopEvent(EventTypes.MOP_PAGE_STATE, {
        releaseDate,
        movieState: trackingState,
        movieAttributes: trackingAttribs
    });
    pageDetails = Object.assign(pageDetails || {}, {
        hasShowtimes
    });
    if (!hasShowtimes) {
        cb && cb();
        return noShowtimesView({
            showTicketingPresale,
            showStreaming,
            hasShowtimes,
            theaterShowtimes,
            showFanalert,
            date
        });
    }
    $(Selectors.SELECTED_FORMAT).text(`${activeFormatFilter || 'standard'} format`);
    if (showtimes.filterAttempted) {
        const viewModel = {
            filterAttempted: showtimes.filterAttempted,
            filteredShowtimes: showtimes.filteredShowtimes,
            chainTheaterInfo: showtimes.filteredChainInfo
        };
        const markup = swig.render('_filteredChain', viewModel);
        $(Selectors.FILTER_LOADING).html(markup);
        $(Selectors.REMOVE_ALL_FILTERS_BTN).on('click', onTheaterFilterBtnClick);
    }
    displayFilteredShowings(activeFormatFilter, movie);
    renderMopBundle();
    if (hasShowtimes && !isDesktop) {
        const buyTicketsBtn = document.querySelector(Selectors.MOBILE_BUY_TICKETS_OUTLINE_BTN_WRAP);
        if (buyTicketsBtn) {
            buyTicketsBtn.addEventListener('click', () => {
                triggerMopEvent(EventTypes.BUY_TICKETS_BELOW_CLICK);
                onBuyTicketsClick();
            });
            buyTicketsBtn.classList.remove(Styles.HIDE);
        }
    }
    const { FormatFilters } = formatFilter;
    triggerMopEvent(EventTypes.DATE_SHOWTIME_FORMAT, {
        showtimePresence: getShowtimePresence(showTicketingPresale, showStreaming, hasShowtimes),
        selectedDate: date,
        formatSelected: activeFormatFilter || FormatFilters.ALL
    });
    cb && cb();
}
function onError(err) {
    debugLog.error(module.name, 'onGroupingsFail', err);
    unshowBusy();
    bannerMPS.insertBannerTopAd({
        hasShowtimes: false,
        selector: Selectors.SHOWTIMES
    });
    bannerMPS.displayBannerTopAd();
}
module.exports = {
    busy: showBusy,
    done: onDone,
    error: onError,
    renderMopBundle,
};
export default module.exports;